export default "__VITE_ASSET__DwgpAJ7U__"